export default [
  {
    path: 'maintenance',
    name: 'maintenance',
    component: () => import('./MaintenancePage.vue')
  }
]
